import { Map } from "@iventis/mapbox-gl";
import { removeSourceOnceMapIsIdle } from "../../engine-mapbox-helpers";

export class MapboxTerrain {
    private readonly map: Map;

    private readonly id: string;

    constructor(map: Map, id: string, terrainUrl: string, bounds?: [number, number, number, number]) {
        this.map = map;
        this.id = id;
        this.addTerrainToMap(terrainUrl, bounds);
    }

    private addTerrainToMap(terrainUrl: string, bounds?: [number, number, number, number]) {
        if (!this.map.getSource(this.id)) {
            this.map.addSource(this.id, {
                type: "raster-dem",
                tiles: [terrainUrl],
                tileSize: 512,
                minzoom: 16,
                // Bug 21009 - Local point based layers disappear on a 3d Sitemap
                // maxzoom can only be maximum of 18 due to mapbox bug, otherwise local point based geometries drop below terrain and can't be seen
                maxzoom: 18,
                bounds,
            });
            this.map.setTerrain({ source: this.id, exaggeration: 1 });
        }
    }

    public remove() {
        // If the terrain being used this terrain then remove it
        if (this.map.getTerrain()?.source === this.id) {
            this.map.setTerrain(undefined);
        }

        removeSourceOnceMapIsIdle(this.map, this.id);
    }
}
